import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthenticationPrompt = ({ forceVisible = false }) => {
  const { isAuthenticated, loading } = useSelector((state) => state.user || {});

  if (!forceVisible && loading !== false) {
    return null;
  }

  if (loading !== false || isAuthenticated) {
    return null;
  }

  return (
    <div className="authentification-prompt-container">
      <h2 className="authentification-prompt-title">Welcome to MATRIX!</h2>
      <p className="authentification-prompt-message">
        Sign in to connect with others, follow your favorite creators, and explore the full potential of our community.
      </p>
      <div className="authentification-prompt-buttonContainer">
        <Link to="/login" className="authentification-prompt-button">
          Sign In
        </Link>
      </div>
    </div>
  );
};

export default AuthenticationPrompt;

